import {RouteRecordRaw} from "vue-router";
import ClubGroundsIndex from '../pages/Index.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/club-grounds',
    name: 'club-grounds.index',
    component: ClubGroundsIndex,
  }
];